/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Course_Totallinked1Inputs */

const zh_course_totallinked1 = /** @type {(inputs: Course_Totallinked1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`已关联内容`)
};

const en_course_totallinked1 = /** @type {(inputs: Course_Totallinked1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Linked Content`)
};

const es_course_totallinked1 = /** @type {(inputs: Course_Totallinked1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contenido vinculado`)
};

/**
* | output |
* | --- |
* | "Linked Content" |
*
* @param {Course_Totallinked1Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const course_totallinked1 = /** @type {((inputs?: Course_Totallinked1Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Course_Totallinked1Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_course_totallinked1(inputs)
	if (locale === "en") return en_course_totallinked1(inputs)
	return es_course_totallinked1(inputs)
});
export { course_totallinked1 as "course_totalLinked" }